export const BNPL_ORDER_PREFIX = "bnpl_order";
